import { render, staticRenderFns } from "./SmsBroadcastMaxRecipientsModal.vue?vue&type=template&id=1e53750a&scoped=true"
import script from "./SmsBroadcastMaxRecipientsModal.vue?vue&type=script&lang=js"
export * from "./SmsBroadcastMaxRecipientsModal.vue?vue&type=script&lang=js"
import style0 from "./SmsBroadcastMaxRecipientsModal.vue?vue&type=style&index=0&id=1e53750a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e53750a",
  null
  
)

export default component.exports